import { LandingV4Testimonial } from '~/landingV4/types/testimonial.types'

const LANDING_V4_TESTIMONIALS: LandingV4Testimonial[] = [
  { id: 'anders', name: 'Anders', avatarSrc: 'landing/v4/avatars/anders.png' },
  { id: 'lisa', name: 'Lisa', avatarSrc: 'landing/v4/avatars/lisa.png', highlighted: true },
  { id: 'catharina', name: 'Catharina', avatarSrc: 'landing/v4/avatars/catharina.png' },
  { id: 'sienna', name: 'Sienna', avatarSrc: 'landing/v4/avatars/sienna.png' },
  { id: 'morten', name: 'Morten', avatarSrc: 'landing/v4/avatars/morten.png' },
  { id: 'truc', name: 'Truc', initial: 'T' },
]

export default LANDING_V4_TESTIMONIALS
